import React, { useState, useEffect } from "react";

import Select from "react-select";
import "../../../PanelGerarRelatorios/index.css";
import { Button } from "rsuite";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";

import {
  getDowloadConfiguracaoExcel,
  getSafras,
  getTipoSafra,
  getProdutor,
} from "../../../../../Services/programation.service";

export const ExportarExcel = () => {
  const [selectOption, setSelectOption] = useState({
    tiposSafra: [],
    safra: [],
  });
  // Filtro OPCIONAL: "Todos os produtores" (vazio) ou um produtor específico
  const [produtor, setProdutor] = useState({ label: "Todos os produtores", value: "" });
  const [selectRelativeSafra, setSelecRelativeSafra] = useState("");
  const [selectRelativeTipoSafra, setSelecRelativeTipoSafra] = useState("");

  useEffect(() => {
    setSelecRelativeSafra(selectOption?.safra?.safraLabel);
    setSelecRelativeTipoSafra(selectOption?.tipoSafra?.tipoSafraLabel);
  }, [selectOption]);

  const getTipoSafrafetch = async () => {
    const { res } = await getTipoSafra();
    if (res?.data) {
      const { data } = res;
      return data
        .filter((tipoSafra) => !tipoSafra.excluido)
        .map((tipoSafra) => ({
          label: tipoSafra.nome,
          value: tipoSafra.id,
        }));
    }
    return [];
  };

  const getSafrasfetch = async () => {
    const { res } = await getSafras();
    if (res?.data) {
      const { data } = res;
      return data
        .filter((safra) => !safra.excluido)
        .map((safra) => ({
          label: safra.nome,
          value: safra.id,
        }));
    }
    return [];
  };

  const handleSelectChangeSafra = (name, label) => {
    return (option) => {
      let safra = safrasQuery.data;
      safra = {
        ...safra,
        [name]: option.value,
        [label]: option.label,
      };
      setSelectOption((prevState) => ({
        ...prevState,
        safra,
      }));
    };
  };

  const handleSelectChangeTipoSafra = (name, label) => {
    return (option) => {
      let tipoSafra = tiposSafraQuery.data;
      tipoSafra = {
        ...tipoSafra,
        [name]: option.value,
        [label]: option.label,
      };
      setSelectOption((prevState) => ({
        ...prevState,
        tipoSafra,
      }));
    };
  };

  const tiposSafraQuery = useQuery(["tiposSafraQuery"], getTipoSafrafetch, []);
  const safrasQuery = useQuery(["safrasQuery"], getSafrasfetch, []);
  const produtoresExcelQuery = useQuery(["produtoresExcelQuery"], async () => {
    const { res } = await getProdutor();
    const lista = (res?.data || [])
      .filter((p) => !p.excluido)
      .map((p) => ({ label: p.nome, value: p.id }));
    return [{ label: "Todos os produtores", value: "" }, ...lista];
  });

  const handleDownloadExcel = async () => {
    // Safra e tipo são obrigatórios (produtor é opcional = todos)
    if (!selectOption?.safra?.safraId || !selectOption?.tipoSafra?.tipoSafraId) {
      toast.warning("Escolha a safra e o tipo de safra.");
      return;
    }
    const { res, mensagem } = await getDowloadConfiguracaoExcel(
      selectOption.tipoSafra.tipoSafraId,
      selectOption.safra.safraId,
      produtor?.value || ""
    );
    // Sem programação o servidor responde explicando o motivo. Antes o código
    // usava res.data direto e quebrava, mostrando erro sem dizer o porquê.
    if (!res?.data) {
      toast.warning(mensagem || "Não foi possível gerar o relatório.");
      return;
    }
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");

    link.href = url;
    // Nome sem caracteres inválidos, e sem "undefined" quando falta campo
    const limpaNome = (t) =>
      String(t || "").replace(/[\\/:*?"<>|]/g, "-").trim();
    const partes = [
      selectRelativeSafra,
      selectRelativeTipoSafra,
      produtor?.value ? produtor.label : null,
    ]
      .filter(Boolean)
      .map(limpaNome)
      .join("_");
    link.setAttribute(
      "download",
      (partes ? "Safra_" + partes : "Relatorio") + ".xlsx"
    );

    link.click();

    URL.revokeObjectURL(url);
  };
  return (
    <div className="generating-container-reports">
      <div style={{ display: "flex", margin: "15px" }}>
        <div className="select-content-relatorio-agrupado">
          Selecione a Safra
          <Select
            defaultValue={{}}
            onChange={handleSelectChangeSafra("safraId", "safraLabel")}
            options={safrasQuery.data}
          />{" "}
        </div>
        <div className="select-content-relatorio-agrupado">
          Selecione o Tipo Safra
          <Select
            defaultValue={{}}
            onChange={handleSelectChangeTipoSafra(
              "tipoSafraId",
              "tipoSafraLabel"
            )}
            options={tiposSafraQuery.data}
          />
        </div>
        <div className="select-content-relatorio-agrupado">
          Produtor (opcional)
          <Select
            value={produtor}
            onChange={setProdutor}
            options={produtoresExcelQuery.data}
          />
        </div>
      </div>{" "}
      <Button
        className="button-generate-reports"
        variant="danger"
        size="lg"
        onClick={handleDownloadExcel}
        style={{ marginLeft: "20px" }}
      >
        Gerar Planilha
      </Button>
    </div>
  );
};
